import { Button } from "primereact/button";

// Screenshot and report to whatsapp.
const EditorFooterActions = ({
  loading,
  handleScreenShot,
  handleLaporKeWhatsapp,
}) => {
  return (
    <div className="elevated-card-tight-vertical w-100 relative row-between-start gap-2">
      <Button
        icon="pi pi-image"
        size="small"
        label="ScreenShot"
        loading={loading}
        severity="info"
        onClick={handleScreenShot}
        rounded
      />
      <Button
        className="leading-tight"
        icon="pi pi-whatsapp"
        size="small"
        label="Lapor Whatsapp"
        loading={loading}
        severity="success"
        onClick={handleLaporKeWhatsapp}
        rounded
      />
    </div>
  );
};

export default EditorFooterActions;
